module.exports = __webpack_public_path__ + "img/sad-smiley-grey.2ea2584c.svg";